<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <generate-invoice />
    </div>
  </div>
</template>

    <script>
    import GenerateInvoice from '../Components/dialogComponents/invoiceDialogs/GenerateInvoice.vue';
    export default {
        name: 'Invoices',
        components: {
            'generate-invoice': GenerateInvoice,
        },
    };
    </script>
